import cf from './cf';
import i1zv5 from './i1zv5_20211024';

export default class i1zv5a extends i1zv5 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
//      name: '予約一括登録',
      name: '定期予約一括登録',
      class: 'i1zv5a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
